import { createAsyncAction } from 'typesafe-actions'
import { put, call, takeEvery, all } from 'redux-saga/effects';
import * as api from '../lib/api/subscriber'
import { getPaidLogsRequestDTO} from '../lib/api/types';

export const getPaidLogs = createAsyncAction(
  'GET_PAID_LOGS',
  'GET_PAID_LOGS_SUCCESS',
  'GET_PAID_LOGS_FAILURE',
)<getPaidLogsRequestDTO, any, Error>();

export type getPaidLogsAction = ReturnType<typeof getPaidLogs.request>

function* getPaidLogsSaga(action:getPaidLogsAction):Generator{
  try {
    const response:any = yield call(
      api.getPaidLogs,
      action.payload
    )
    yield put(getPaidLogs.success(response.data))
  } catch (e) {
    yield put(getPaidLogs.failure(e))
  }
}

export function* paidLogsSaga(){
  yield all([takeEvery(getPaidLogs.request, getPaidLogsSaga)])
}
